export default "__VITE_ASSET__Dh6qpao7__"